import {Title} from '@mantine/core';
import type {FC} from 'react';

type Props = {
  title: string;
};

export const ClipSectionTitle: FC<Props> = ({title}) => (
  <Title
    order={2}
    className="min-h-[40px] w-full bg-background-1 pl-16 text-lg font-bold leading-[40px] text-black-1"
  >
    {title}
  </Title>
);
